import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{~#if (has-block)~}}
  {{yield}}
{{~else~}}
  {{this.linkTitle}}
{{~/if~}}

*/
{
  "id": "oFEGjILt",
  "block": "[[[41,[48,[30,1]],[[[18,1,null]],[]],[[[1,[30,0,[\"linkTitle\"]]]],[]]]],[\"&default\"],false,[\"if\",\"has-block\",\"yield\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/@ember/legacy-built-in-components.4938bbb1/node_modules/@ember/legacy-built-in-components/components/link-to.hbs",
  "isStrictMode": false
});